import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { replyForAdmin } from "../../actions/updateHelp";
import { withRouter } from "react-router-dom";
import axios from "axios";
import $ from "jquery";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import Moment from "moment";
import { Link } from "react-router-dom";
import { baseUrl } from "../pages/baseUrl";
class HelpQueryModal extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      id: this.props.id,
      description: "",
      message: "",
      tstatus: "",
      issueImage: "",
      username: user.name,
      replyBy: this.props.userrecords.replyTo,
      showResults: false,
      showTeaxtArea: true,
      errors: {},
      staticImage:'/img/support.jpg'
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.userrecords) {
      this.setState({
        tstatus: nextProps.userrecords.status,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.helpdata !== undefined &&
      nextProps.helpdata.help !== undefined &&
      nextProps.helpdata.help.data !== undefined &&
      nextProps.helpdata.help.data.message !== undefined
    ) {
      this.setState({
        description: "",
        issueImage: "",
        errors: {},
      });
    }
  }

  getNodesToRemoveFromElement = (stringContent) => {
    var div = document.createElement("div");
    div.innerHTML = stringContent;
    var text = div.textContent || div.innerText || "";
    return text;
  };
  showChatHtml = () => {
    const html = [];
    const classThis = this;
    this.props.record.map(function (value, i) {
      if (value.replyBy == 2) {
        html.push(
          <>
            <div class="incoming">
              <div class="bubble">
                <div>
                <p>{classThis.getNodesToRemoveFromElement(value.query)}</p>
                </div>
                {value.queryImage !== undefined && value.queryImage !== "" && (
                  <div>
                  <a
                    data-toggle="modal" data-target="#supportImageModel" onClick={() => {
                      classThis.setState({ Image: baseUrl +
                        "/static/helpIssue/" +
                        value.queryImage })
                    }}
                    href=''
                    target="_blank"
                  >
                    <img
                      src={baseUrl + "/static/helpIssue/" + value.queryImage}
                    />
                  </a>
                  </div>
                )}
                <div>
                <span className="time-right">
                  {Moment(value.createdAt).format("lll")}
                </span>
                </div>
              </div>
            </div>
          </>
        );
      }
      if (value.replyBy == 1) {
        html.push(
          <>
            <div class="outgoing">
              <div class="bubble lower">
                <div>
                  <p>{classThis.getNodesToRemoveFromElement(value.query)}</p>
                </div>
                {value.queryImage !== undefined && value.queryImage !== "" && (
                  <div>
                  <a
                   data-toggle="modal" data-target="#supportImageModel" onClick={() => {
                    classThis.setState({ Image: baseUrl +
                      "/static/helpIssue/" +
                      value.queryImage })
                  }}
                    href=""
                    target="_blank"
                  >
                    <img
                      src={baseUrl + "/static/helpIssue/" + value.queryImage}
                    />
                  </a>
                  </div>
                )}
                <div>
                <span className="time-right">
                  {Moment(value.createdAt).format("lll")}
                </span>
                </div>
              </div>
            </div>
          </>
        );
      }
    });
    return html;
  };
  onChange = (e) => {
    this.setState({
      message: "",
      errors: {},
    });
    if (e.target.id === "tstatus") {
      this.setState({ tstatus: e.target.value });
    }
    if (e.target.name === "issueImage") {
      var issueImage = e.target.files[0];
      if (issueImage == undefined) {
        this.setState({ issueImage:false });
        return false;
      }
      var fileSize = e.target.files[0].size;
      if (fileSize > 1000000) {
        this.setState({
          invalidImage: "Maximum 1 MB Image allowed.",
          firstSubmitIsDisabled: true,
          userUploadImage: false,
        });
        return false;
      }

      if (!issueImage.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        this.setState({
          invalidImage: "Please select valid Front image jpeg,png,gif.",
          firstSubmitIsDisabled: true,
          userUploadImage: false,
        });
        return false;
      }

      this.setState({
        issueImage: issueImage,
      });
    }
  };
  handleCommentChange = (event, editor) => {
    var data = event.target.value
    console.log("HANDLECOMMENTCHANGE",data)
      this.setState({ description: data });
    this.setState({
      showResults: this.state.name === null ? false : true,
    });
  };
  onUserUpdate = (e) => {
    e.preventDefault();

    if(!this.state.description){
      toast.error("Please enter discription")
      return false
    }
    if (this.state.description.replace(/\s+/g, '').length == 0) {
      toast.error("Please enter a valid discription")
      return false
    }
    this.setState({btnDisable:true})
    setTimeout(() => {
      this.setState({btnDisable:false})
    }, 500);


    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    const { user } = this.props.auth;
    const formData = new FormData();
    formData.append("_id", this.props.match.params.id);
    formData.append("user_id", user.id);
    formData.append("description", this.state.description);
    formData.append("issueImage", this.state.issueImage);
    formData.append("tstatus", this.state.tstatus);
    this.props.replyForAdmin(formData, config);
  };
  onStatusUpdate = (e) => {
    e.preventDefault()
    axios
      .post(baseUrl + "/api/suportStatus-update", {
        _id: this.props.match.params.id,
        tstatus: this.state.tstatus,
      })
      // alert(this.state.tstatus)
      .then((res) => {
        if (res.status === 200) {
          // alert(res.data.message)
          this.setState({ message: res.data.message });
        }
      });
  };

  render() {
    const { errors } = this.state;
    const { user } = this.props.auth;
    return (
      <div class="">
        <div class="">
          <div>
            <form noValidate onSubmit={this.onStatusUpdate} id="update-user">
              <input type="reset" defaultValue="Reset" className="d-none" />
              <div class="row">
                <div class="col-md-6">
                  <div class="pt-2 text-white">
                    <b>Ticket Id:</b> {this.props.userrecords.id}
                  </div>
                  <span class="text-success">{this.state.message}</span>
                </div>
                <div class="col-md-6 ">
                  <div class="status_box">
                    <div class="pt-2 text-white">
                      <b>Status:</b>
                    </div>
                    <div class="ml-md-3 mr-md-3">
                      {" "}
                      <select
                        class="browser-default custom-select"
                        id="tstatus"
                        onChange={this.onChange}
                        value={this.state.tstatus}
                      >
                        <option value="0">Pending</option>
                        <option value="1">Resolved</option>
                      </select>
                    </div>
                    <div class="">
                      <button class="btn btn-primary send-status-btn" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </form>
            <hr />
            <h5 className="op05 mb-3 text-white">
              Subject: {this.props.userrecords.subject}
            </h5>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="w_chating_box w_chating_box_left">
                <div class="scrool_chating">
                  <div class="incoming">
                    <div class="bubble">
                      <div>
                      <p>
                        {this.getNodesToRemoveFromElement(
                          this.props.userrecords.description
                        )}
                        {this.props.userrecords.issueImage != undefined &&
                          this.props.userrecords.issueImage != "" &&
                          this.props.userrecords.issueImage != null && (
                            <>
                              <a
                               data-toggle="modal" data-target="#supportImageModel" onClick={() => {
                                this.setState({ Image: baseUrl +
                                  "/static/helpIssue/" +
                                  this.props.userrecords.issueImage })
                              }}
                                href="#"
                                target="_blank"
                              >
                                <img
                                  src={
                                    baseUrl +
                                    "/static/helpIssue/" +
                                    this.props.userrecords.issueImage
                                  }
                                />
                              </a>
                            </>
                          )}
                      </p>
                      </div>
                      <div>
                      <span className="time-right">
                        {Moment(this.props.userrecords.date).format("lll")}
                      </span>
                      </div>
                    </div>
                  </div>
                  {this.showChatHtml()}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="w_chating_box">
                <h5 class="mb-3">Send Your Message Form Here:</h5>
                <form noValidate onSubmit={this.onUserUpdate} id="update-user">
                  <div class="">
                    <textarea
                      // editor={ClassicEditor}
                      name = "description"
                      value={this.state.description}
                      onChange={this.handleCommentChange}
                      placeholder="Enter Description"
                      className="form-control form_control_textarea"
                      data={this.state.description}
                    ></textarea>
                  </div>

                  <div className="form-group">
                    <div className="add_fileinput form-control">
                      Add File
                      <input
                        className="profile_input form-control"
                        type="file"
                        name="issueImage"
                        onChange={this.onChange}
                      />
                    </div>
                    <span className="text-danger">
                      {this.state.invalidImage}
                    </span>
                    <div>
                        <img 
                        src={this.state.issueImage?
                        URL.createObjectURL(this.state.issueImage)
                        :this.state.staticImage} alt ="..." height="90px" width="120px" />
                      </div>
                  </div>
                  <div className="tr">
                    <button class="btn btn-primary" type="submit" 
                    disabled ={this.state.btnDisable }
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="modal fade supportImageModel" id="supportImageModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-body p-0">
                      <img src={this.state.Image} alt="noimg" />
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

HelpQueryModal.propTypes = {
  replyForAdmin: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  helpdata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  helpdata: state.helpdata,
  errors: state.errors,
});

export default connect(mapStateToProps, { replyForAdmin })(
  withRouter(HelpQueryModal)
);
